const API_ADD_COMPONENT_STATUS_REQUEST = 'API_ADD_COMPONENT_STATUS_REQUEST';
const API_ADD_COMPONENT_STATUS_SUCCESS = 'API_ADD_COMPONENT_STATUS_SUCCESS';
const API_ADD_COMPONENT_STATUS_FAILURE = 'API_ADD_COMPONENT_STATUS_FAILURE';
const RESET_ADD_COMPONENT_STATUS = 'RESET_ADD_COMPONENT_STATUS';
const SAVE_TIME_TAKEN = 'SAVE_TIME_TAKEN';
const SAVE_STATUS = 'SAVE_STATUS';

export const saveStatus = payload => ({
  type: SAVE_STATUS,
  payload,
});

export const saveTimeTaken = payload => ({
  type: SAVE_TIME_TAKEN,
  payload,
});

export const resetAddComponentStatus = () => ({
  type: RESET_ADD_COMPONENT_STATUS,
});

export const addComponentStatusRequest = () => ({
  type: API_ADD_COMPONENT_STATUS_REQUEST,
});

export const addComponentStatusSuccess = payload => ({
  type: API_ADD_COMPONENT_STATUS_SUCCESS,
  payload,
});

export const addComponentStatusFailure = payload => ({
  type: API_ADD_COMPONENT_STATUS_FAILURE,
  payload,
});

const initialState = {
  status: null,
  timeTaken: null,
  isFetched: false,
  fetching: false,
  error: null,
  componentStatus: null,
};

export function addComponentStatus(state = initialState, action) {
  switch (action.type) {
    case SAVE_STATUS:
      return {
        ...state,
        status: action.payload,
      };
    case SAVE_TIME_TAKEN:
      return {
        ...state,
        timeTaken: action.payload,
      };
    case RESET_ADD_COMPONENT_STATUS:
      return {
        ...initialState,
      };
    case API_ADD_COMPONENT_STATUS_REQUEST:
      return {
        ...state,
        fetching: true,
      };
    case API_ADD_COMPONENT_STATUS_SUCCESS:
      return {
        ...state,
        fetching: false,
        isFetched: true,
        componentStatus: action.payload,
      };
    case API_ADD_COMPONENT_STATUS_FAILURE:
      return {
        ...state,
        fetching: false,
        isFetched: false,
        error: action.payload,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/addComponentStatus.js